import type { BrowserWindow, Experiments } from '@wix/thunderbolt-symbols'
import { tabClasses } from '@wix/thunderbolt-commons'
import { isExperimentOpen } from '@wix/thunderbolt-experiments'

const KEYBOARD_NAVIGATION_ACCESSIBILITY_KEYS = ['Tab', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft']
const BASIC_ACCESSIBILITY_KEYS = ['Tab']

export const accessibilityUtils = (window: BrowserWindow, experiments: Experiments) => {
	const isRepeaterKeyboardNavigationAvailable = isExperimentOpen(
		experiments,
		'specs.thunderbolt.repeater_keyboard_navigation'
	)

	const FOCUS_RING_KEYS = isRepeaterKeyboardNavigationAvailable
		? KEYBOARD_NAVIGATION_ACCESSIBILITY_KEYS
		: BASIC_ACCESSIBILITY_KEYS

	return {
		addFocusRingAndKeyboardTabbingOnClasses: (event: KeyboardEvent): void => {
			if (FOCUS_RING_KEYS.includes(event.key)) {
				// TODO: renderer check how to change it
				// TODO: Think of a better way to get the site container in page features
				const target: HTMLElement = window!.document.getElementById('SITE_CONTAINER')!
				target.classList.add(...tabClasses)
			}
		},
		removeKeyboardTabbingOnClass: (e: PointerEvent | MouseEvent): void => {
			// if pointerType is Unknown (meaning that the event was not generated by a mouse device, a pen/stylus device or a touch, such as a finger), do not remove class
			if ('pointerType' in e && e.pointerType === '') {
				return
			}

			const target: HTMLElement = window!.document.getElementById('SITE_CONTAINER')!
			target.classList.remove('keyboard-tabbing-on')
		},
	}
}
